"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BillItemsDialog',
  data: function data() {
    return {
      dialogVisible: false,
      billInfo: {
        merchantType: '核销商家',
        merchantName: '家家乐',
        periodStart: '2025-05-01 00:00:00',
        periodEnd: '2025-05-31 23:59:59'
      },
      searchForm: {
        page: 1,
        limit: 20,
        tradeNo: '',
        orderNo: '',
        orderTimeStart: '2025-05-01 00:00:00',
        orderTimeEnd: '2025-05-31 23:59:59',
        orderStatus: '',
        saleMethod: '',
        orderType: '',
        isInBill: '1'
      },
      // 静态 mock 数据
      tableData: {
        total: 20,
        list: [{
          tradeNo: '2133751777443701 2891723',
          platformOrderNo: '2133751777443701 2891723',
          merchantOrderNo: '2891723',
          saleAttr: '红芋莧(500g),榛子骨(500g),鲳鱼湖北雪米+*25kg(500g),西美系茉片(1000g),超市口袋大号(7000根/件)',
          orderAmount: 200,
          settledAmount: 180,
          actualAmount: 180,
          verifiedAmount: 0,
          orderStatus: '已完结',
          isInBill: true,
          orderTime: '2026-05-18 21:04:15',
          reconciliationRemark: '',
          financeRemark: ''
        }, {
          tradeNo: '2133751777443701 2891723',
          platformOrderNo: '2133751777443701 2891723',
          merchantOrderNo: '2891723',
          saleAttr: '红芋莧(500g),榛子骨(500g),鲳鱼湖北雪米+*25kg(500g),西美系茉片(1000g),超市口袋大号(7000根/件)',
          orderAmount: 200,
          settledAmount: 180,
          actualAmount: 0,
          verifiedAmount: 0,
          orderStatus: '已完结',
          isInBill: false,
          orderTime: '2026-05-18 21:04:15',
          reconciliationRemark: '',
          financeRemark: ''
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      if (row) {
        this.billInfo.merchantName = row.merchantName || this.billInfo.merchantName;
        this.billInfo.merchantType = row.merchantType || this.billInfo.merchantType;
        this.billInfo.periodStart = row.periodStart || this.billInfo.periodStart;
        this.billInfo.periodEnd = row.periodEnd || this.billInfo.periodEnd;
      }
      this.dialogVisible = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
    }
  }
};